import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { TextService } from 'src/app/core/service/text.service';
import { UserService } from 'src/app/services/user.service';
import { Transformation } from 'src/@utility/model-transformation';

@Component({
  selector: 'app-user-auto-complete',
  templateUrl: './user-auto-complete.component.html',
  styleUrls: ['./user-auto-complete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UserAutoCompleteComponent),
      multi: true,
    },
  ],
})
export class UserAutoCompleteComponent implements OnInit, ControlValueAccessor {
  @Input() optionLabel = 'fullName'; // Field of a suggested object to resolve and display.
  @Input() multiple = false; // Specifies if multiple values can be selected.
  @Input() disabled = false; // When present, it specifies that the component should be disabled.
  @Input() selected: any; // model value
  @Input() formControl: FormControl; // form control
  @Input() appendTo = 'body'; // appendTo
  @Output() formControlChange = new EventEmitter<FormControl>();
  @Output() onSelected = new EventEmitter<any>();
  suggestions: any[] = []; // An array of suggestions to display.
  generalTexts: any = {
    search: { labelId: 'PH_USER_SEARCH' },
    noData: { labelId: 'L_NODATA' },
  };

  constructor(
    private textService: TextService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.textService
      .convert(this.generalTexts)
      .subscribe((texts) => (this.generalTexts = texts));
  }

  searchUsers(ev: any) {
    if (ev.query.length) {
      this.formControl?.markAsTouched();
      this.userService.findUsers(ev.query).subscribe((res) => {
        const filterIds = this.multiple
          ? this.selected?.map((m) => m.id) || []
          : [];
        this.suggestions = res.body
          .filter((f) => !filterIds.includes(f.id))
          .map((s) => Transformation.user(s));

        this.formControl?.setErrors(
          this.suggestions.length || this.formControl?.value
            ? null
            : { userNotFound: true }
        );
      });
    }
  }

  onSelect() {
    this.formControl?.setValue(this.selected);
    this.formControlChange?.emit(this.formControl);
    this.onSelected?.emit(this.selected);
  }

  registerOnChange(fn: any): void {}

  registerOnTouched(fn: any): void {}

  setDisabledState(isDisabled: boolean): void {}

  writeValue(value: any): void {
    this.selected = value ?? null;
  }
}
